import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import * as AuthActions from './actions/auth.action';
import { getCCFilters } from './reducers/user_settings.reducer';
import * as AuthSelectors from './selectors/auth.selectors';

@Injectable({
    providedIn: 'root'
})

export class AuthFacade {

    public authFormLoader$ = this._store$.select(AuthSelectors.authFormLoader);
    public isThirdPartyLogin$ = this._store$.select(AuthSelectors.isThirdPartyLogin);
    public crmData$ = this._store$.select(AuthSelectors.crmData);
    public verifyOtpInProgress$ = this._store$.select(AuthSelectors.verifyOtpInProgress);
    public isUserDataFetched$ = this._store$.select(AuthSelectors.isUserDataFetched);
    public isIframeAbleLogin$ = this._store$.select(AuthSelectors.isIframeAbleLogin);

    constructor(private _store$: Store) { }


    clearState() {
        this._store$.dispatch(AuthActions.clearState());
    }


    fetchUserSettings() {
        this._store$.dispatch(AuthActions.fetchUserData())
    }


    /**
     * Get contract control saved filters
     * @param filterKey 
     * @returns 
     */
    getCCFilter(filterKey: string) {
        return this._store$.select(getCCFilters(filterKey));
    }



    /**
     * Dispatches an action to verify the OTP (One-Time Password).
     *
     * @param otp - The OTP string to be verified.
     * @returns void
     */
    verifyOtp(otp: string): void {
        this._store$.dispatch(AuthActions.verifyOtp(otp));
    }

}